import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { LoadingBarService } from '@ngx-loading-bar/core';

import {
  HeaderService,
  InvoiceService
} from '../../../shared';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.scss']
})
export class InvoiceListComponent implements OnInit {
  typeComponent = "invoice";

  currentUrl = "/panel/invoice";

  dataList;

  pag;
  filters;
  cacheObj;

  invoiceRequest;

  totalInvoices;

  constructor(
    private headerService: HeaderService,
    private loadingBarService: LoadingBarService,
    private activatedRoute: ActivatedRoute,
    private invoiceService: InvoiceService
  ) {
    if (this.activatedRoute.snapshot.params.pag) {
      this.pag = this.activatedRoute.snapshot.params.pag;
    } else {
      this.pag = 1;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle('Notas fiscais');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);

    this.dataList = {};

    this.translateFilter();
  }

  invoiceList(filters = "") {
    this.loadingBarService.stop();

    this.loadingBarService.start();

    if(this.invoiceRequest) {
      this.invoiceRequest.unsubscribe();
    }

    this.invoiceRequest = this.invoiceService.listInvoices(filters).subscribe((response) => {
      this.loadingBarService.complete();

      this.dataList = response;

      this.totalInvoices = response['total'];
    });
  }

  setPag(setPag) {
    this.pag = setPag;

    this.translateFilter();
  }

  translateFilter(obj?) {
    this.filters = [];

    if (obj) {
      this.cacheObj = obj;
    }

    _.forOwn(this.cacheObj, (value, key) => {
      this.filters.push(`${key}=${value}`);
    });

    this.invoiceList(`?pageNumber=${this.pag}&`+this.filters.join('&'));
  }

}
